import { ITelemetryItem } from "@microsoft/applicationinsights-core-js";

// Add device data to all App Insights tracking events
export const DeviceTelemetryInitializer = (item: ITelemetryItem) => {
    item.data!.device_width = window.innerWidth;
    item.data!.device_height = window.innerHeight;

    return true;
};
